module.exports = __webpack_public_path__ + "img/mobile_app.600e0361.png";